<div class="dialog">
        <h2 mat-dialog-title>  {{variables.sureContinueMessage}}  </h2>
        <div class="dialog-box-s">
                <mat-dialog-actions class="button-group">
                        <app-button typeBtn="secondary" message="{{variables.cancel}}" mat-dialog-close ></app-button>
                        <app-button typeBtn="primary" mat-dialog-close message="{{variables.remove}}" mat-dialog-close mat-dialog-close="true"></app-button>
                </mat-dialog-actions>
        </div>
</div>